module.exports = __webpack_public_path__ + "img/fire02.b6dd2984.png";